'use strict';

module.exports = ['$scope', '$location', '$window', '$timeout', 'PlantSvc', function ($scope, $location, $window, $timeout, PlantSvc) {
    // ------------------
    // Helper functions
    // ------------------
    function saveFields(new_field) {
        $scope.error = undefined;
        PlantSvc.createOrderField($scope.plant, new_field).success(function (data) {
            $scope.order_fields.push(data);
        }).error(function (error) {
            $scope.error = error;
        });
    }

    function validate() {
        let fieldNames = $.map($scope.order_fields, function (val) {
            return val.name;
        });

        if ($.inArray($scope.order_field.name_input, fieldNames) === -1) {
            $scope.order_field_form.field_name.$setValidity("unique", true);
        }
        else {
            $scope.order_field_form.field_name.$setValidity("unique", false);
        }
    }
    // ------------------
    // scope functions
    // ------------------
    $scope.addOrderField = function (form) {
        validate();
        // do submit
        if (form.$valid) {
            // add field to the list
            const new_field = {
                name: $scope.order_field.name_input,
                field_type: $scope.order_field.type_input.value,
                visible_to_customer: $scope.order_field.visible_to_customer,
                is_required: $scope.order_field.is_required
            };

            // save on the server
            saveFields(new_field);

            $scope.order_field.name_input = '';
            $scope.order_field.type_input = $scope.order_field_types[0];
            form.submitted = false;
        } else {
            form.submitted = true;
        }
    };

    $scope.removeOrderField = function (index) {
        $scope.error = undefined;
        PlantSvc.deleteOrderField($scope.plant, $scope.order_fields[index].id).then(function () {
            $scope.order_fields.splice(index, 1);
        }, function (result) {
            $scope.error = result.data.message;
        });
    };

    $scope.updateOrderField = function (order_field) {
        PlantSvc.updateOrderField($scope.plant, order_field).success(function (data) {

        }).error(function (error) {
            $scope.error = error;
        });
    };

    $scope.renameOrderField = function (order_field, new_name) {
        order_field.name = new_name;
        return PlantSvc.renameOrderField($scope.plant, order_field.id, new_name);
    };

    // ------------------
    // Watches
    // ------------------
    $scope.$watch('order_field.name_input', function () {
        validate();
    });

    // ------------------
    // Fetch Data
    // ------------------
    PlantSvc.getOrderFields($scope.plant).success(function (data) {
        $scope.order_fields = data;
    });


    // ------------------
    // Events
    // ------------------
    $scope.$on('order_field.drop-model', function (event, item) {
      const newIndex = item.index();
      const fieldId = angular.element(item).scope().order_field.id;
      return PlantSvc.moveOrderField($scope.plant, fieldId, newIndex);
    });

    // ------------------
    // Initialization
    // ------------------
    $scope.order_fields = $scope.order_fields || [];
    $scope.order_field_types = [
        {name: "Text", value: "Text"},
        {name: "TextArea", value: "TextArea"},
        {name: "Checkbox", value: "Checkbox"},
        {name: "Time", value: "Time"},
        {name: "Date", value: "Date"}
    ];
    $scope.order_field = {type_input: $scope.order_field_types[0]};
    $scope.error = undefined;

    $scope.dragulaOptions = {
      accepts: function () {
        return true; // elements can be dropped in any of the `containers` by default
      },
      copy: function () {
        return false;
      },
      moves: function (el, source, handle) {
        if (angular.element(source).hasClass("order-field-row")) {
          if (angular.element(source).find('.draggable-item').length === 1) {
            return false;
          }
        }
        return angular.element(handle).hasClass('draggable-handle'); // elements are always draggable by default
      },
      mirrorContainer: $('[pd-dragula-container]')[0],
      removeOnSpill: false,
      revertOnSpill: true,
    };

}];